import {
  DocumentData,
  FirestoreError,
  QuerySnapshot,
  Unsubscribe,
} from "firebase/firestore";
import { getIdb } from "../utils/bridges/methods";
import {
  convertOfflineAppointmentToOnlineAptFormat,
  getAllQueuesQuery,
} from "../apis/tryst/get-all-queues";
import queryClient from "../instances/react-query-client";
import { OfflineAppointment } from "./types";
import dayjs from "dayjs";

export default async function setupAppointmentListener({
  clinicId,
  date,
  onAptSnapshot,
  onError,
}: {
  clinicId: string;
  date: Date;
  onAptSnapshot?: (Snapshot: QuerySnapshot<DocumentData, DocumentData>) => void;
  onError?: (error: FirestoreError) => void;
  docids: string[];
}): Promise<Unsubscribe> {
  // const appointmentRef = collection(firestore, "appointments");
  // const queries: QueryConstraint[] = [
  //   where("bid", "==", getMe().business.id),
  //   where("clinic_id", "==", clinicId),
  //   where(
  //     "full_date",
  //     ">=",
  //     Timestamp.fromMillis(dayjs(date).startOf("day").unix() * 1000)
  //   ),
  //   where(
  //     "full_date",
  //     "<=",
  //     Timestamp.fromMillis(dayjs(date).endOf("day").unix() * 1000)
  //   ),
  //   where("archive", "==", false),
  //   where(
  //     "doctor_oid",
  //     "in",
  //     getMe().doctors.map((doctor) => doctor.oid)
  //   ),
  // ];
  // const aptQuery = query(appointmentRef, ...queries);
  // return onSnapshot(
  //   aptQuery,
  //   { includeMetadataChanges: true },
  //   (snapshot) => {
  //     onAptSnapshot?.(snapshot);
  //   },
  //   (error) => {
  //     onError?.(error);
  //     console.log("Error in apt snapshot", error);
  //   },
  //   () => {
  //     console.log("Snapshot listener completed");
  //   }
  // );
  return (() => {}) as Unsubscribe;
}

export async function updateIntoIdbAndUpdateView(
  apts: OfflineAppointment[],
  toDeleteAids: string[] = []
) {
  try {
    await getIdb().appointments.bulkPut(apts);
    await publishIntoLegacyTodayAptTable(apts);
    if (toDeleteAids.length > 0) {
      const deleteFromAptRequest =
        getIdb().appointments.bulkDelete(toDeleteAids);
      const deleteFromTodayAptRequest =
        getIdb().todayAppointments.bulkDelete(toDeleteAids);

      await Promise.all([deleteFromAptRequest, deleteFromTodayAptRequest]);
    }
    queryClient.invalidateQueries(getAllQueuesQuery({}));
  } catch (e) {
    console.error(e);
  }
}

export async function publishIntoLegacyTodayAptTable(
  apts: OfflineAppointment[]
) {
  try {
    const todaysApts = apts.filter((apt) =>
      dayjs(new Date(apt.full_date)).isSame(dayjs(), "day")
    );

    const today = dayjs().format("YYYY-MM-DD");
    const aptConfig = await getIdb()?.table("misc")?.get("aptConfig");

    if (!!aptConfig?.config && aptConfig.config.localAptDate !== today) {
      //today has changed.
      //flush appointment db
      //flush the idb misc key
      getIdb().todayAppointments.clear();
      getIdb().table("misc").delete("aptConfig");
      aptConfig.config = {
        ...aptConfig.config,
        localAptUpdatedAt: undefined,
        localAptDate: undefined,
      };
    }

    const isTodaysAptBeingFetched = !!todaysApts.length;

    if (isTodaysAptBeingFetched) {
      const newAptConfigInMisc = todaysApts.reduce<Record<string, string>>(
        (acc, curr) => {
          acc[curr.clinic_id] = new Date().toISOString();
          return acc;
        },
        {}
      );
      const formattedTodayApts =
        await convertOfflineAppointmentToOnlineAptFormat(todaysApts);
      getIdb()
        ?.todayAppointments?.bulkPut?.(
          formattedTodayApts.map((item) => ({ ...item }))
        )
        ?.then(() => {
          getIdb()?.misc?.put?.({
            ...aptConfig,
            key: "aptConfig",
            config: {
              ...aptConfig?.config,
              localAptDate: today,
              localAptUpdatedAt: {
                ...aptConfig?.config?.localAptUpdatedAt,
                ...newAptConfigInMisc,
              },
            },
          });
        });
    }
  } catch (e) {
    console.log("LEGACY TODAY APT PUBLISH ERROR", e);
  }
}
